import React from 'react';
import { ON_OFF_COURTS } from '../on-off-reports';

const Legend = () => (
  <div className="legend">
    <div className="legend-item-container">
      {ON_OFF_COURTS.map(({ court, name }) => (
        <div className="legend-item" key={court}>
          <div className={`legend-color court-${court}`} />
          <div className="legend-text">{name}</div>
        </div>
      ))}
    </div>
    <div className="legend-note">
      All metrics refer to points scored per 100 possessions
    </div>
  </div>
);

export default Legend;
